<template>
  <div>
    <multiselect :name="name_select"  v-model="value" @input="setHiddenValue()" :searchable="true" :options="options" label="identifiable_name" track-by="id"></multiselect>
    <input type="hidden" :name="name_select" :value="hiddenValue" >
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

    export default {

      components: { Multiselect },
      mounted() {

        //Clean some special characters in input
        for (var i = 0; i < this.options.length; i++){
          this.options[i].identifiable_name = this.decoder(this.options[i].identifiable_name);
        }

        this.value = this.options.find(option => option.id === this.default_value);
        if(this.value !== undefined) {
          this.value.identifiable_name = this.decoder(this.value.identifiable_name);
          this.hiddenValue = this.default_value;
        }
      },
      methods: {
        setHiddenValue() {

          this.hiddenValue = (this.value.id);
          console.log(this.hiddenValue);
        },
        decoder(str) {
          var textArea = document.createElement('textarea');
          textArea.innerHTML = str;
          var textDecoded = textArea.value;
          textArea.remove();
          return textDecoded;
        }
      },
      props: {
          options: {
              type: Array,
              required: true
          },
          default_value :{
            type: [String,Number],
            required : false,
            default : null
          },
          name_select :{
            type: String,
            required : true,
          }

      },
      data () {
          return {
              value: null,
              hiddenValue : null
          }
      }
    }
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>